// extracted by mini-css-extract-plugin
export var bodySections = "_7c-8";
export var gray = "_7c-7";
export var green = "_7c-4";
export var iconContainer = "_7c-9";
export var iconWidgetContainer = "_7c-1";
export var phoneIcon = "_7c-2";
export var red = "_7c-5";
export var statusDot = "_7c-3";
export var widgetContainer = "_7c-0";
export var yellow = "_7c-6";